module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "drop-zone dz-clickable",
    style: (_vm.dropzoneAreaStyle),
    attrs: {
      "id": 'dropzone-' + _vm._uid,
      "data-upload-path": "/api/admin/crop",
      "data-image-previews": "id"
    }
  }, [_c('div', {
    staticClass: "dz-message",
    style: (_vm.dropzoneMessageStyle)
  }, [_vm._v("\n      " + _vm._s(_vm.uploadMessage) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1144cefa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/DropFile.vue
// module id = 2094
// module chunks = 1